import React from "react";
import { Box, Button, Typography, Dialog, DialogContent } from "@mui/material";

export default function EventSubmissionPopup({
  logoutDialogOpen,
  handleLogoutClose,
  handleConfirmLogout,
}) {
  return (
    <Box>
      <Dialog
        open={logoutDialogOpen}
        onClose={handleLogoutClose}
        PaperProps={{
          sx: {
            borderRadius: "34px", // Apply 100px border radius to the dialog box
            overflow: "hidden", // Ensure content stays within rounded corners
          },
        }}
      >
        <DialogContent
          sx={{
            textAlign: "center",
            padding: "24px 16px",
            display: "flex", // Use flexbox
            flexDirection: "column", // Stack items vertically
            alignItems: "center", // Center items horizontally
          }}
        >
          {/* Title */}
          <Typography
            color="#2A4876"
            variant="h6"
            fontWeight="bold"
            gutterBottom
          >
            Add a short description?
          </Typography>

          {/* Message */}
          <Typography variant="body2" color="textSecondary">
            While adding a description is optional for articles and blogs,
            including a brief overview can help readers quickly understand what
            your content is about—especially if it’s a longer piece. A short
            summary can make your article more appealing and help attract users
            who are interested in the topic. Would you like to add a description
            before submitting?
          </Typography>

          {/* Buttons */}
          <Box mt={3} display="flex" justifyContent="center" gap={2}>
            <Button
              onClick={handleLogoutClose} // Confirms logout
              sx={{
                textTransform: "none",
                borderRadius: "34px",
                backgroundColor: "#AAB6C8",
                color: "#2A4876",
                fontWeight: "bold",
                padding: "12px 44px",
                "&:hover": { backgroundColor: "#C4CED8" },
              }}
            >
              Yes
            </Button>
            <Button
              onClick={handleConfirmLogout} // Closes the popup
              sx={{
                textTransform: "none",
                borderRadius: "34px",
                backgroundColor: "#2A4876",
                color: "#FFFFFF",
                fontWeight: "bold",
                padding: "12px 44px",
                "&:hover": { backgroundColor: "#002A5C" },
              }}
            >
              No
            </Button>
          </Box>
        </DialogContent>
      </Dialog>
    </Box>
  );
}
